var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-follow countinfo"
  }, [_c('div', {
    staticClass: "count friends"
  }, [_c('span', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "value-inner"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.countInfo && _vm.countInfo.friends_count || 0)))])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "label-inner"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.friends')))])])]), _vm._v(" "), _c('div', {
    staticClass: "count fans"
  }, [_c('span', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "value-inner"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.countInfo && _vm.countInfo.follower_count || 0)))])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "label-inner"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.fans')))])])]), _vm._v(" "), _c('div', {
    staticClass: "count following"
  }, [_c('span', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "value-inner"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.countInfo && _vm.countInfo.following_count || 0)))])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "label-inner"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.following')))])])]), _vm._v(" "), _c('div', {
    staticClass: "count diamond"
  }, [_c('span', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "value-inner"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.userInfo && _vm.userInfo.diamond || 0)))])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "label-inner"
  }, [_vm._v(_vm._s(_vm.$t('liveroom.diamond')))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };